import { render } from "./Pagemode.vue?vue&type=template&id=64a35a64&scoped=true"
import script from "./Pagemode.vue?vue&type=script&lang=js"
export * from "./Pagemode.vue?vue&type=script&lang=js"

import "./Pagemode.vue?vue&type=style&index=0&id=64a35a64&lang=sass&scoped=true"

import exportComponent from "C:\\Riman\\Web\\Alex\\newmapper\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64a35a64"]])

export default __exports__